import React from "react";
import { Link } from "react-router-dom";

import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";

import "./ReturnToResults.css";

function ReturnToResults(props) {
  let classDetails = props.classDetails;
  let classAssessments = props.classAssessments;
  let classAssessmentsArray = props.classAssessmentsArray;
  let teachers = props.teachers;
  let assessment = props.assessment;
  let name = classDetails.name;
  let gradeLevel = classDetails.grade_level;
  let gradeLevel1 = classDetails.grade_level1;
  let gradeLevel2 = classDetails.grade_level2;
  let trialClass = classDetails.trial_class;
  let schoolid = props.schoolid;
  let teacherid = props.teacherid;

  // console.log(props)

  return (
    <Link
      to={`/results/detail`}
      state={{
        classDetails: { classDetails },
        classAssessments: { classAssessments },
        teachers: { teachers },
        assessment: { assessment },
        name: { name },
        gradeLevel: { gradeLevel },
        gradeLevel1: { gradeLevel1 },
        gradeLevel2: { gradeLevel2 },
        trialClass: { trialClass },
        schoolid: { schoolid },
        teacherid: { teacherid },
      }}
    >
      <img
        src={process.env.PUBLIC_URL + "/assets/imgs/arrow-left.svg"}
        alt="Back"
        className="back-arrow"
        style={{ cursor: "pointer" }}
      />
    </Link>
  );
}

export default ReturnToResults;
